import MidSection from '../components/MidSection';

function Home() {
  return (
    <main>
      <MidSection />
    </main>
  );
}

export default Home;
